import { jsx as _jsx } from "react/jsx-runtime";
import { Spinner as Spin } from '@chakra-ui/react';
const Loader = ({ className, testid }) => (_jsx(Spin, { className: className, "data-testid": testid || 'loader' }));
export default Loader;
